export enum ModalType {
    None,
    Defects,
    Release,
    Delete,
    Scrap,
    Reprint,
    PrintHistory,
    MovementsHistory,
    ConsumptionIssuing,
    ConsumptionReturn,
    PartPallet
}
